import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { api } from "../lib/api";
import { fmonth, fmt, num, run, shiftMonth, thisMonth, useLoad } from "../lib/util";
import { Badge, Btn, Card, Field, Input, cellCls } from "../components/kit";
import { useSchool } from "./ctx";
import { OPENING } from "./Overview";

export default function Opening() {
  const { products, tick, bump } = useSchool();
  const [op, reload] = useLoad(async () => (await api.get("/s/opening")).data, [tick]);
  const [f, setF] = useState(null);
  const [reason, setReason] = useState("");
  const pname = (id) => products.find((p) => p.id === id);
  useEffect(() => {
    setF(op ? { month: op.month, items: op.items.map((i) => ({ ...i, description: pname(i.product_id)?.name || i.description, unit: pname(i.product_id)?.unit || i.unit || "" })) } : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [op, products]);
  const status = op ? op.status : "nao_informado";
  const save = async () => {
    const body = {
      month: f.month, reason: reason || null, version: op?.version ?? null,
      items: f.items.map((i) => ({ product_id: i.product_id || null, qty: i.qty ?? 0, description: i.description || null, unit: i.unit || null })),
    };
    if (await run(() => api.put("/s/opening", body), "Estoque anterior registrado")) {
      setReason("");
      reload();
      bump();
    }
  };
  const set = (i, r) => setF({ ...f, items: f.items.map((x, j) => (j === i ? r : x)) });
  const edit = (i, k, v) => set(i, { ...f.items[i], [k]: v, ...(k === "description" ? { product_id: null } : {}) });
  return (
    <Card data-testid="opening-panel">
      <div className="flex flex-wrap justify-between items-center gap-3 mb-3">
        <div>
          <h3 className="font-heading font-bold text-[#0B192C]">Estoque do mês anterior (o que sobrou)</h3>
          <p className="text-xs text-slate-500">Registre o saldo que sobrou de cada gênero. Ele vira o estoque inicial do mês.</p>
        </div>
        <Badge tone={OPENING[status][1]} data-testid="opening-status">{OPENING[status][0]}</Badge>
      </div>
      {!f ? (
        <Btn variant="outline" data-testid="opening-manual-button" onClick={() => setF({ month: shiftMonth(thisMonth(), -1), items: [] })}>Informar saldos manualmente</Btn>
      ) : (
        <div className="space-y-3">
          <div className="flex flex-wrap items-end gap-4">
            <Field label="Mês do saldo final (mapa anterior)" className="max-w-xs"><Input data-testid="opening-month-input" type="month" value={shiftMonth(f.month, -1)} onChange={(e) => e.target.value && setF({ ...f, month: shiftMonth(e.target.value, 1) })} /></Field>
            <div className="text-sm text-slate-600 pb-2" data-testid="opening-start-month">O mapa em andamento começa em <b>{fmonth(f.month)}</b>, com estes saldos como estoque inicial.</div>
          </div>
          <div className="overflow-x-auto rounded-xl border">
            <table className="w-full mapia-table text-sm">
              <thead><tr><th>Gênero</th><th>Un.</th><th className="num">Sobra do mês anterior</th><th /></tr></thead>
              <tbody>
                {f.items.map((it, i) => (
                  <tr key={i}>
                    <td><input data-testid={`opening-name-${i}`} className={cellCls} value={it.description || ""} onChange={(e) => edit(i, "description", e.target.value)} /></td>
                    <td><input data-testid={`opening-unit-${i}`} className={`${cellCls} w-20`} value={it.unit || ""} disabled={!!it.product_id} onChange={(e) => edit(i, "unit", e.target.value)} /></td>
                    <td><input data-testid={`opening-qty-${i}`} type="number" step="any" className={`${cellCls} text-right`} value={it.qty ?? ""} onChange={(e) => edit(i, "qty", num(e.target.value))} /></td>
                    <td><button data-testid={`opening-remove-${i}`} onClick={() => setF({ ...f, items: f.items.filter((_, j) => j !== i) })}><Trash2 className="w-4 h-4 text-red-500" /></button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="text-xs text-slate-500">Total de itens: {f.items.length} · soma: {fmt(f.items.reduce((a, b) => a + (b.qty || 0), 0))}</div>
          {status === "gravado" && <Field label="Motivo da correção (obrigatório — fica no histórico)"><Input data-testid="opening-reason-input" value={reason} onChange={(e) => setReason(e.target.value)} /></Field>}
          <div className="flex flex-wrap gap-2">
            <Btn variant="outline" data-testid="opening-add-row" onClick={() => setF({ ...f, items: [...f.items, { product_id: null, description: "", unit: "kg", qty: null }] })}><Plus className="w-4 h-4" />Adicionar gênero</Btn>
            <Btn data-testid="opening-save-button" onClick={save}>{status === "gravado" ? "Corrigir saldos" : "Registrar estoque anterior"}</Btn>
          </div>
        </div>
      )}
    </Card>
  );
}
